<script setup lang="ts">
definePageMeta({
  name: 'podcasts',
})

const { data } = useArticleCards((card) => card.hasPodcast)
</script>

<template>
  <div>
    <LayoutBreadCrumbs :background="false" class="bg-coral-20 text-red-60" />
    <UiPodcastsHero />
    <UContainer
      id="main-content"
      as="main"
      class="py-16"
    >
      <h2 class="mx-auto mt-4 mb-16 text-center font-headline text-3xl font-normal text-green-60 md:text-5xl">
        Artikler om podkastepisoder
      </h2>
      <section v-if="data?.length" class="flex flex-wrap justify-center gap-8 lg:gap-12">
        <CardsArticle
          v-for="article in data"
          :key="article.id"
          :article="article"
        />
      </section>
    </UContainer>
  </div>
</template>
